import React, { useContext } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

import MetaTitle from "./MetaTitle";
import Title from "./Title";
import Content from "./Content";
import ButtonGroup from "./ButtonGroup";
import { HeaderContext } from "contexts/";
import DynamicLink from "./DynamicLink";
import { Icon } from "../Icons";
export default function MembershipBenefitsList(props) {
	const { size } = useContext(HeaderContext);

	const fields = props.data?.fields;

	const verticalPadding = "py-5";
	const isContainer = "sm";

	const SignupButton = () => {
		return (
			<>
				<ButtonGroup
					additionalClasses=""
					alignButtons="center"
					btn1={{
						url: `${process.env.APP_URL}/membership/join`,
					}}
					buttonWidth={{ xs: 12 }}
					button1Variant="light"
					button1Children={
						<>
							Become a Member
							<div className="chevron">
								<Icon icon="carrotUp" />
							</div>
						</>
					}
				/>
				<style jsx>{`
					.chevron {
						display: inline-block;
						transform: rotate(90deg);
						margin-left: 5px;
					}
				`}</style>
			</>
		);
	};

	const CheckMark = () => {
		return (
			<img src="https://images.ctfassets.net/mdag2z2o3c18/5qO41tOcpWuUvaUeCbqadK/a0e0f69b564c21947ce87fb1e394f036/foursquare-check-in.svg" />
		);
	};

	return (
		<section className={`outerWrapper ${verticalPadding}`}>
			<Container fluid className={`g-0 `}>
				<div className="innerWrapper">
					<Container fluid className={`${isContainer ? `container-${isContainer}` : " "} g-0 `}>
						{fields.content &&
							fields?.content.map((component, index) => {
								const model = component?.sys?.contentType?.sys.id;

								const key = component?.sys?.id;

								if (model === "metaTitle") {
									return <MetaTitle key={key} metaTitle={component} />;
								} else if (model === "title") {
									return (
										<Row key={key} className="justify-content-center g-0">
											<Col
												// xs={12}
												// md={11}
												// xl={12}
												className="px-4 d-flex justify-content-center"
											>
												<div className="max-width-900">
													<Title title={component} />
												</div>
											</Col>
										</Row>
									);
								} else if (model === "content") {
									return (
										<Row key={key} className=" justify-content-center g-0  ">
											<Col className="px-4 d-flex justify-content-center" xs={12} md={9}>
												<div className=" max-width-700">
													<Content content={component} />
												</div>
											</Col>
										</Row>
									);
								} else {
									return <React.Fragment key={index}></React.Fragment>;
								}
							})}

						<div className="listContainer ">
							<Row className="g-0">
								<Col xs={12} md={6}>
									<div className="benefitsList px-4">
										<div className="">
											<p className="benefitsTitle ">
												{fields?.statisticsList?.benefitsList[0].title}
											</p>
											<div className="d-block d-md-none d-flex justify-content-center">
												<SignupButton />
											</div>
										</div>
										<ul className=" ">
											{fields?.statisticsList?.benefitsList &&
												fields?.statisticsList?.benefitsList.map((benefit, index) => {
													for (const type in benefit) {
														//this first one is a title
														if (index === 0 && type === "title") {
															return <React.Fragment key={index}></React.Fragment>;
														} else {
															return (
																<li
																	key={index}
																	className="benefitItem d-flex align-items-center"
																>
																	<div className="d-inline pe-2 d-md-none">
																		<CheckMark />
																	</div>
																	{/* <span dangerouslySetInnerHTML={{__html:benefit[type]}}></span> */}

																	{benefit[type].includes("<") ? (
																		<span
																			dangerouslySetInnerHTML={{
																				__html: benefit[type],
																			}}
																		/>
																	) : (
																		benefit[type]
																	)}
																</li>
															);
														}
													}
												})}
										</ul>
									</div>
								</Col>
								<Col className="d-none d-md-block" md={3}>
									{fields?.statisticsList?.benefitsList && fields?.statisticsList?.MembersOnly && (
										<div className="MembersOnlyList px-4">
											<div className=" d-flex justify-content-center">
												<p className="membersTitle">
													{fields?.statisticsList?.MembersOnly[0].title}
												</p>
											</div>

											<ul>
												<li>
													<p>&nbsp;</p>
												</li>
												{fields?.statisticsList?.benefitsList.map((benefit, index) => {
													if (index + 1 === fields?.statisticsList?.benefitsList.length) {
														return <React.Fragment key={index}></React.Fragment>;
													} else {
														return (
															<li
																key={index}
																className="membersListItem d-flex justify-content-center"
															>
																<CheckMark />{" "}
															</li>
														);
													}
												})}
											</ul>
											<div className="d-none d-md-block d-flex justify-content-center">
												<SignupButton />
											</div>
										</div>
									)}
								</Col>
								<Col className="d-none d-md-block" md={3}>
									{fields?.statisticsList?.benefitsList && fields?.statisticsList?.allCommunity && (
										<div className="communityList px-4">
											<div className=" d-flex justify-content-center">
												<p className="communityTitle">
													{fields?.statisticsList?.allCommunity[0].title}
												</p>
											</div>
											<ul>
												{fields?.statisticsList?.benefitsList.map((benefit, index) => {
													for (const type in benefit) {
														//this first one is a title
														if (index === 0 && type === "title") {
															return <React.Fragment key={index}></React.Fragment>;
														} else {
															const isTrue = fields?.statisticsList?.allCommunity[index];
															if (isTrue) {
																return (
																	<li
																		key={index}
																		className="communityItem d-flex justify-content-center"
																	>
																		<img src="https://images.ctfassets.net/mdag2z2o3c18/5qO41tOcpWuUvaUeCbqadK/a0e0f69b564c21947ce87fb1e394f036/foursquare-check-in.svg" />
																	</li>
																);
															} else {
																return (
																	<li key={index} className="communityItem">
																		&nbsp;
																	</li>
																);
															}
														}
													}
												})}
											</ul>
										</div>
									)}
								</Col>
							</Row>
						</div>
					</Container>
				</div>
			</Container>

			<style jsx>{`
				ul {
					list-style: none;
					padding-left: 0px;
				}

				li {
					min-height: 68px;
					max-height: 68px;
					padding: 10px 0px;
				}
				li:last-child {
					border: none;
				}
				.benefitsTitle {
					font-size: 20px;
					color: #444444;
					margin-bottom: 0;
					margin-left: 10px;
					padding-top: 30px;
					padding-bottom: 20px;
					font-weight: bold;
					text-align: center;
				}

				.benefitsList {
					background: white;

					border-radius: ${size === "sm" || size === "xs" ? "30px" : "30px 0px 0px 30px"};
					box-shadow: 0px 30px 50px #0000002e;
					margin-top: 68px !important;
				}
				.benefitItem {
					color: #717171;
					font: 16px;
					margin: 0px 0px 0px 20px;

					border-bottom: 1px solid #e6e6e6;
				}
				.MembersOnlyList {
					background: #245a91;
					border-radius: 30px;
					padding-bottom: 0.5em;
					box-shadow: 0px 30px 50px #0000002e;
				}
				.membersTitle {
					color: white;
					font-weight: bold;
					font-size: 20px;
					margin: 20px 0px;
					padding: 10px 0px 0px;
					text-align: center;
				}
				.membersListItem {
					border-bottom: 1px solid #4976a4;
				}
				.communityList {
					background: white;
					border-radius: 0px 30px 30px 0px;
					box-shadow: 0px 30px 50px #0000002e;
					margin-top: 68px !important;
				}
				.communityTitle {
					color: #717171;
					font-size: 20px;
					padding-top: 30px;
					padding-bottom: 5px;
					text-align: center;
				}

				.communityItem {
					border-bottom: 1px solid #e6e6e6;
				}
				.listContainer {
					margin-top: 4em;
					border-radius: 30px;
				}
			`}</style>
		</section>
	);
}
